import { Container } from '@mui/material';
import { EditPatient } from 'components/templates';

export const EditPatientView = () => {
  return (
    <Container>
      <EditPatient />
    </Container>
  );
};
